import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=1344eac0&scoped=true&"
import script from "./ContactSupport.vue?vue&type=script&lang=js&"
export * from "./ContactSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1344eac0",
  null
  
)

export default component.exports